import { BaseClient } from '../BaseClient';
import {
  ReferralSource,
  ReferralSourceList,
} from '../compiled-protos/referral_source';
import { ReferralSourceServiceClient } from '../compiled-protos/referral_source.client';

class ReferralSourceClient extends BaseClient {
  self: ReferralSourceServiceClient;

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new ReferralSourceServiceClient(this.transport);
  }

  public async Create(req: ReferralSource) {
    return await this.self.create(req, this.getMetaData()).response;
  }

  public async Get(req: ReferralSource) {
    return await this.self.get(req, this.getMetaData()).response;
  }

  public async Update(req: ReferralSource) {
    return await this.self.update(req, this.getMetaData()).response;
  }

  public async Delete(req: ReferralSource) {
    return await this.self.delete(req, this.getMetaData()).response;
  }

  public async BatchGet(req: ReferralSource) {
    return await this.self.batchGet(req, this.getMetaData()).response;
  }
}

export { ReferralSource, ReferralSourceList, ReferralSourceClient };
